import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
@Component({
    selector: 'company-addresses-form',
    templateUrl: './company-addresses-form.component.html',
    styleUrls: ['./company-addresses-form.component.scss'],
    standalone: false
})
export class CompanyAddressesFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  cristalisOrganizationId: number = 251251251;
  isCristalisOrganization: boolean;
  countries: any[];
  sessionConsultant: boolean;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private attributionDao: AttributionDao,
    private referenceDao: ReferenceDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this);
    combineLatest([
      this.attributionDao.getOrganization(),
      this.referenceDao.getCountries(),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([organization, countries]: any) => {
        this.countries = countries;
        this.isCristalisOrganization =
          this.cristalisOrganizationId === organization.id;
      });
  }

  onSubmit() {
    this.form.markAsDirty();
    if (this.isCristalisOrganization && !this.sessionConsultant) {
      const address = this.form.value.owners?.[0].company.addressSiegeSocial;
      if (
        address?.street == null ||
        address?.zipCode == null ||
        address?.city == null ||
        address?.country == null
      ) {
        return;
      }
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
